import { render, staticRenderFns } from "./BeautyUidGuidePopup.vue?vue&type=template&id=0bb5c292&scoped=true&"
import script from "./BeautyUidGuidePopup.vue?vue&type=script&lang=js&"
export * from "./BeautyUidGuidePopup.vue?vue&type=script&lang=js&"
import style0 from "./BeautyUidGuidePopup.vue?vue&type=style&index=0&id=0bb5c292&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb5c292",
  null
  
)

export default component.exports